import produce from 'immer'
import { createContext } from 'react'

export interface FileUploadState {
  id: string
  file: File
  upload?: { abort: (terminate?: boolean) => void }
}

export type ComposerFilesState = Record<string, FileUploadState>

export const ComposerMediaContext = createContext<{ files: ComposerFilesState, dispatch: React.Dispatch<any> }>({
  files: {}, dispatch: (_action: any) => { /** no-op */ }
})

export const ACTION_ADD_CONTEXT_FILES = 'ACTION_ADD_CONTEXT_FILES'
export const ACTION_REMOVE_CONTEXT_FILES = 'ACTION_REMOVE_CONTEXT_FILES'
export const ACTION_UPDATE_CONTEXT_FILE = 'ACTION_UPDATE_CONTEXT_FILE'
export const ACTION_RESET_CONTEXT_FILES = 'ACTION_RESET_CONTEXT_FILES'

export function mediaReducer(state: ComposerFilesState, action: { type: string, payload?: any }): ComposerFilesState {
  switch (action.type) {
    case ACTION_ADD_CONTEXT_FILES: {
      const next = produce(state, draft => {
        action.payload.forEach((file: FileUploadState) => {
          draft[file.id] = { ...file }
        })
      })

      return next
    }

    case ACTION_REMOVE_CONTEXT_FILES: {
      const next = produce(state, draft => {
        action.payload.forEach((id: string) => {
          delete draft[id]
        })
      })

      return next
    }

    case ACTION_UPDATE_CONTEXT_FILE: {
      const next = produce(state, draft => {
        const { id, file, upload } = action.payload
        draft[id] = {
          id,
          file: file || draft[id].file,
          upload
        }
      })

      return next
    }

    case ACTION_RESET_CONTEXT_FILES:
    default:
      return {}
  }
}
